import type * as React from 'react';
import { getIntrinsicElementProps, slot } from '@fluentui/react-components';
import type { GroundingMenuErrorProps, GroundingMenuErrorState } from './GroundingMenuError.types';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render GroundingMenuError.
 *
 * The returned state can be modified with hooks such as useGroundingMenuErrorStyles_unstable,
 * before being passed to renderGroundingMenuError_unstable.
 *
 * @param props - props from this instance of GroundingMenuError
 * @param ref - reference to root HTMLElement of GroundingMenuError
 */
export const useGroundingMenuError_unstable = (
  props: GroundingMenuErrorProps,
  ref: React.Ref<HTMLDivElement>,
): GroundingMenuErrorState => {
  return {
    components: {
      root: 'div',
      image: 'img',
      heading: 'div',
      body: 'div',
    },
    root: slot.always(
      getIntrinsicElementProps('div', {
        ref,
        ...props,
      }),
      { elementType: 'div' },
    ),
    image: slot.optional(props.image, {
      defaultProps: {
        role: 'presentation',
      },
      elementType: 'img',
    }),
    heading: slot.optional(props.heading, { elementType: 'div' }),
    body: slot.optional(props.body, { elementType: 'div', renderByDefault: props.children ? true : undefined }),
  };
};
